import React from 'react';
import { Modal, Spin } from 'antd';

const style = {
  modal: {
    backgroundColor: 'rgba(0,0,0,0)',
  },
  spinner: {
    textAlign: 'center',
  }
}

const Spinner = (props) => {
  if (props.visible === false) {
    return <div></div>;
  }

  return (
    <Modal 
      visible={props.visible}
      footer={null}
      style={style.modal}
      closable={false}
      markClosable={false}
      width={64}
    >
      <Spin style={style.spinner} size='large' />
    </Modal>
  );
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner.js